import React from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import {
  Input,
  // Input,
} from '../../../components/elements';

const Wrapper = styled.nav`
  padding: 1rem;
  border-bottom: 1px solid #f5f8fa;
  padding-bottom: 1rem;
`;

const BoxWrapper = styled.nav`
  &&& {
    background: #f6f6f6;
  }
`;

const PlaceSearch = ({ orderReference, setOrderReference }) => (
  //   const handlePush = (args, key) => {
  //     const newRoutState = omit(routeState, key);
  //     history.push(
  //       `/orders-dashboard${qs.stringify(
  //         {
  //           ...newRoutState,
  //           ...args,
  //           page: 1,
  //         },
  //         true,
  //       )}`,
  //     );
  //   };

  <Wrapper>
    <BoxWrapper className="box">
      <div className="columns">
        <div className="column is-3">
          <Input
            label="Order Reference"
            type="text"
            value={orderReference}
            onChange={e => {
              setOrderReference(e);
            }}
          />
        </div>
      </div>
    </BoxWrapper>
  </Wrapper>
);
export default withRouter(PlaceSearch);
